<template>
    <div class="flex flex-1 flex-col bg-white max-h-screen">

        <Notifications></Notifications>
        <template v-if="auction && auction.s == AUCTION_LIVE_STATUS_AUCTIONING && auction.m">
            <div class="flex px-2 py-2 justify-center items-center text-semibold text-center">{{ auction.m }}</div>
        </template>

        <Streaming v-if="auction.s == AUCTION_LIVE_STATUS_AUCTIONING"></Streaming>
        <!-- <Messages v-if="auction.md == 4"></Messages> -->

        <template v-if="auction.s == AUCTION_LIVE_STATUS_AUCTIONING">
            <div class="flex">
                <div class="flex p-2 justify-center items-center">
                    <transition name="slide-fade" mode="out-in">
                        <Paddle v-if="winner" :key="winner.w" :paddle="winner.w" bg-color="#FFF01F" text-color="#000000" width="50px" />
                        <Paddle v-else :key="0" :paddle="''" bg-color="#f1f1f1" text-color="#000000" width="50px" />
                    </transition>
                </div>
                <div class="py-2 pr-2 flex flex-col flex-1 justify-center">
                    <div class="uppercas2e text-xs">
                        {{ $t('general.lot') }} {{ lot.no }}
                    </div>
                    <div class="text-sm">
                        <v-clamp autoresize :max-lines="4">{{ description }}</v-clamp>
                    </div>
                    <div v-if="lot.emin" class="flex flex-no-wrap text-sm text-gray-500">
                        <span class="mr-1">{{ $t('general.est') }}: </span>
                        <money-format
                            :value="lot.emin"
                            locale="ro"
                            currency-code="eur"
                            :subunits-value="false"
                            :hide-subunits="true">
                        </money-format>
                        <span class="mx-1">&ndash;</span>
                        <money-format
                            :value="lot.emax"
                            locale="ro"
                            currency-code="eur"
                            :subunits-value="false"
                            :hide-subunits="true">
                        </money-format>
                    </div>
                </div>
            </div>
            <div v-if="lot.s == LOT_AUCTION_STATUS_OPEN" class="flex">
                <div class="flex flex-1 justify-center items-center divide-x divide-gray-300 border-gray-300 border-t border-b">
                    <div v-if="lot.p > 0" class="flex flex-1 flex-col text-center p-2">
                        <div class="text-xs text-gray-500">{{ $t('bids.current') }} (EUR)</div>
                        <div class="text-2xl">
                            <AnimatedNumber :value="lot.p" :precision="0" />
                        </div>
                    </div>
                    <div v-if="lot.k > 0" class="flex flex-1 flex-col text-center p-2">
                        <div class="text-xs text-gray-500">{{ $t('bids.ask') }} (EUR)</div>
                        <div class="text-2xl">
                            <AnimatedNumber :value="lot.k" :precision="0" />
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="[4, 5].includes(auction.md)">
                <div v-if="lot.s == LOT_AUCTION_STATUS_OPEN && bids.length > 0" class="flex flex-1 paddles text-black">
                    <TransitionGroup v-if="bids" name="paddles-rise" tag="div">
                        <div v-for="(bid, index) in bids.slice(0, max_paddles)" :key="index">
                            <Paddle :paddle="bid.w" width="50" height="100%" bg-color="#FFF01F" text-color="#000000" />
                        </div>
                    </TransitionGroup>
                    <div v-if="bids.length > bidsCount" class="more ml-4 text-2xl">+ {{ bids.length - bidsCount }}</div>
                </div>
                <div v-else-if="lot.s == LOT_AUCTION_STATUS_OPEN && bids.length == 0 && warn" class="flex flex-1 text-black justify-center items-center">
                    {{ $t(warn.type, {'value': warn.params}) }}
                </div>
                <div v-else-if="lot.s == LOT_AUCTION_STATUS_OPEN && bids.length == 0 && !warn" class="flex flex-1 text-black text-lg justify-center items-center">

                </div>
            </template>

            <Messages v-else></Messages>

            <div v-if="lot.s == LOT_AUCTION_STATUS_OPEN" class="flex px-4 py-4 border-gray-300 border-t border-b">
                <button
                    v-if="user.id && user.approval_status == 2"
                    :disabled="! canBid"
                    @click="confirmbid"
                    class="bid-button select-none relative w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                    <div class="absolute z-10 bg-white top-0 bottom-0 left-0 rounded-tl-md rounded-bl-md opacity-50 transition-all" :style="{'width': lotTimer}"></div>
                    <span v-if="canBid && holding">{{ $t('bids.hold') }}</span>
                    <span v-else-if="canBid" class="flex z-10">
                        <span>{{ $t('bids.bid') }}</span>
                        <span class="mx-1">
                            <AnimatedNumber :value="lot.k" :precision="0" />
                        </span>
                        <span class="uppercase">eur</span>
                    </span>
                    <span v-else-if="isHighestBidder" class="flex z-10"><img class="w-6 h-6 mr-2" src="@live/assets/images/clap.svg">{{ $t('bids.highest', {'value': winner.p}) }}</a></span>
                    <span v-else-if="isBidder" class="flex z-10">{{ $t('bids.sent', {'value': lot.k}) }}</span>
                    <span v-else>{{ $t('bids.wait') }}</span>

                </button>
                <a v-else-if="user.id && user.approval_status != 2" href="/account" class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                    {{ $t('account.review') }}
                </a>
                <a v-else :href="`/${locale}/login`" class="w-full select-none inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                    {{ $t('account.login') }}
                </a>
                
                <!--
                <select v-if="[4, 5].includes(auction.md) && this.user && this.user.id && canBid" :disabled="! canBid" v-model="moreAmount" @change="confirmBidMore" class="w-24 ml-4 inline-flex items-center justify-center bg-black text-white px-4 py-3 text-base font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" :placeholder="$t('bids.more_mobile')">
                    <option :value="0">{{ $t('bids.more_mobile') }}</option>
                    <option v-for="step in steps" :value="step" :key="step">
                        <money-format
                            :value="step"
                            locale="ro"
                            currency-code="eur"
                            :subunits-value="false"
                            :hide-subunits="true">
                        </money-format>
                    </option>
                </select>
                -->
               
            </div>
            <div v-else-if="![4, 5].includes(auction.md) && lot.s == LOT_AUCTION_STATUS_PENDING" class="flex flex-1 text-black text-sm items-center justify-center border-gray-300 border-t">
                {{ $t('bids.wait') }}
            </div>
            <div v-else-if="![4, 5].includes(auction.md) && lot.s == LOT_AUCTION_STATUS_SOLD" class="flex flex-1 flex-col text-black text-sm items-center justify-center border-gray-300 border-t">
                <div>{{ $t('bids.sold') }}</div><div v-if="isHighestBidder">{{ $t('bids.congrats') }}</div>
            </div>
            <div v-else-if="![4, 5].includes(auction.md) && lot.s == LOT_AUCTION_STATUS_UNSOLD" class="flex flex-1 text-black text-sm items-center justify-center border-gray-300 border-t">
                {{ $t('bids.pass') }}
            </div>
            <div v-else-if="![4, 5].includes(auction.md)" class="flex flex-1 text-black text-sm items-center justify-center border-gray-300 border-t">
                {{ $t('bids.wait') }}
            </div>
        </template>
        <template v-else>
            <div class="flex flex-1 flex-col justify-center items-center">
                <div v-if="auction.m" class="flex justify-center items-center bg-red-600 w-full p-2">
                    {{ auction.m }}
                </div>
                <div class="flex flex-1 justify-center items-center p-8">
                    <img class="w-64" src="@live/assets/images/logo-20-m.svg" />
                </div>
                <div v-if="auction.n" class="flex flex-1 justify-center items-center text-center p-8">
                    {{ auction.n }}
                </div>
                <div class="flex flex-1 justify-center items-center p-8">
                    <div class="text-center" v-if="auction.s == AUCTION_LIVE_STATUS_STANDBY">
                        {{ $t('general.standby') }}
                    </div>
                    <div class="text-center" v-if="auction.s == AUCTION_LIVE_STATUS_BREAK">
                        {{ $t('general.break') }}
                    </div>
                    <div class="text-center" v-if="auction.s == AUCTION_LIVE_STATUS_ENDED">
                        <div>{{ isRecallWindowActive ? $t('general.ended_recall') : $t('general.ended') }}</div>
                        <template v-if="isRecallWindowActive">
                            <div class="mt-4 text-4xl font-semibold tracking-widest">{{ formattedRecallTimer }}</div>
                            <div class="mt-4 text-sm leading-relaxed">{{ $t('general.ended_recall_help') }}</div>
                            <button @click.prevent="openLotsForRecall" type="button" class="mt-4 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-black text-base font-medium text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                                {{ $t('general.show_unsold_lots') }}
                            </button>
                        </template>
                    </div>
                    <div class="flex flex-col space-y-4 items-center" v-if="auction.s == AUCTION_LIVE_STATUS_HOME">
                        <span>{{ $t('general.redirect_home', { seconds: timeToRedirect }) }}</span>
                        <button @click.prevent="redirectHome(true)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-black text-base font-medium text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                            {{ $t('general.redirect_now') }}
                        </button>
                    </div>
                    <div class="flex flex-col space-y-4 items-center" v-if="auction.s == AUCTION_LIVE_STATUS_OLD">
                        <span>{{ $t('general.redirect_old', { seconds: timeToRedirect }) }}</span>
                        <button @click.prevent="redirectOld(true)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-black text-base font-medium text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                            {{ $t('general.redirect_now') }}
                        </button>
                    </div>
                    <div class="flex flex-col space-y-4 items-center" v-if="auction.s == AUCTION_LIVE_STATUS_RELOAD">
                        <span>{{ $t('general.reload_all', { seconds: timeToRedirect }) }}</span>
                        <button @click.prevent="reloadAll(true)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-black text-base font-medium text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                            {{ $t('general.reload_now') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <ConfirmBid @confirmbid="bid" />
        
        <BidMore :more-amount="moreAmount" @confirmbidmore="bidMore" @cancel="moreAmount = 0" />

    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Streaming from './Streaming'
import Paddle from '../global/Paddle'
import AnimatedNumber from '../global/AnimatedNumber'
import VClamp from 'vue-clamp'
import { Constants } from '../../constants'
import { Functions } from '../../functions'
import A10 from '../global/A10'
import Notifications from '../global/Notifications'
import BidMore from '../modals/BidMore'
import ConfirmBid from '../modals/ConfirmBid'
import Messages from '../global/Messages.vue'

export default {
    data () {
        return {
            ...Constants,
            max_paddles: 5,
            isBidding: false,
            bid_more: null,
            holding: false,
            timeToRedirect: null,
            moreAmount: 0,
        }
    },
    components: {
        Streaming, Paddle, AnimatedNumber, VClamp, Notifications, BidMore, ConfirmBid, Messages
    },
    computed: {
        ...mapGetters({
            currency: 'getCurrency',
            locale: 'getLocale',
            user: 'getUser',
            auction: 'getAuction',
            lot: 'getLot',
            selectedLot: 'getSelectedLot',
            showLots: 'getShowLots',
            bids: 'getBids',
            winner: 'getWinner',
            isHighestBidder: 'getIsHighestBidder',
            isWinner: 'getIsWinner',
            isBidder: 'getIsBidder',
            warn: 'getWarn',
            timer: 'getTimer',
            recallTimer: 'getRecallTimer',
            steps: 'getNext5Steps',
        }),
        colSpan () {
            return {
                'col-span-3': this.showLots == true,
                'col-span-6': this.showLots == false
            }
        },
        canBid () {
            if(this.isBidding) return false
            if(this.lot.s != this.LOT_AUCTION_STATUS_OPEN) return false
            if(!this.user) return false
            if(this.winner && (this.winner.uid === this.user.id && this.lot.k != this.lot.r)) return false
            if(this.bids.filter(el => el.uid == this.user.id).length > 0) return false
            return true
        },
        bidButtonType() {
            if(this.lot.warn == 0) {
                return 'is-dark'
            } else {
                return 'is-danger'
            }
        },
        description () {
            let artist = ''
            if(this.lot.a) {
                artist = this.lot.a + ', '
            }
            return artist + this.lot.t
        },
        auctionStatus () {
            if(! this.auction) return null
            return this.auction.s
        },
        lotTimer () {
            if(! this.timer) return 0;
            if(! this.auction) return 0;
            let ileana = this.auction.ileana
            if(! ileana) return 0;

            return (this.timer / (ileana.secondsPerLot / 10) * 100) + '%';
        },
        bidsCount() {
            if(this.bids && Array.isArray(this.bids) && this.bids.length > 0) {
                return this.bids[0].t ? this.bids[0].t : this.bids.length;
	    }
            return 0;
        },
        isRecallWindowActive() {
            return !!this.auction
                && [4, 5].includes(this.auction.md)
                && this.auction.s == this.AUCTION_LIVE_STATUS_ENDED
                && this.recallTimer > 0
        },
        formattedRecallTimer() {
            let totalSeconds = this.recallTimer > 0 ? this.recallTimer : 0
            let minutes = Math.floor(totalSeconds / 60)
            let seconds = totalSeconds % 60

            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        }
    },
    watch: {
        auctionStatus(s) {
            if(s == this.AUCTION_LIVE_STATUS_HOME) {
                this.redirectHome()
            } else if(s == this.AUCTION_LIVE_STATUS_OLD) {
                this.redirectOld()
            } else if(s == this.AUCTION_LIVE_STATUS_RELOAD) {
                this.reloadAll()
            }
        }
    },
    methods: {
        async confirmbid() {
            this.holding = false
            if(this.user.live_bid_protection_status === 1) {
                this.$modal.show('confirm-bid')
            } else {
                this.bid()
            }
        },
        async bid() {
            this.$modal.hide('confirm-bid')
            this.holding = false
            this.isBidding = true
            try {
                const bid = await this.$store.dispatch('sendBid', {
                    auction_id: this.auction.id,
                    lot_id: this.lot.id,
                    amount: this.lot.k
                })
                this.isBidding = false
            } catch (e) {
                this.isBidding = false
            }
        },
        async bidMore () {
            this.isBidding = true
            try {
                await this.$store.dispatch('sendAmount', {
                    auction_id: this.auction.id,
                    lot_id: this.lot.id,
                    amount: this.moreAmount
                })
                this.isBidding = false
                this.lot.k = this.moreAmount
                this.$modal.hide('bid-more')
            } catch (e) {
                this.isBidding = false
                this.$modal.hide('bid-more')
            }
        },
        confirmBidMore() {
            // return;

            if(this.moreAmount == 0) return
            this.$modal.show('bid-more')
        },
        suggestHold() {
            this.holding = true
        },
        resetSuggestHold() {
            this.holding = false
        },
        getRndInteger(min, max) {
            return Math.floor(Math.random() * (max - min) ) + min;
        },
        redirectHome (now) {
            if(now === true) {
                window.location.replace('https://www.artmark.ro')
                return;
            }

            this.timeToRedirect = this.getRndInteger(5, 30)
            window.setTimeout(() => { window.location.replace('https://www.artmark.ro') }, this.timeToRedirect * 1000)
        },
        redirectOld (now) {
            if(now === true) {
                window.location.replace('https://live.artmark.ro')
                return;
            }

            this.timeToRedirect = this.getRndInteger(5, 30)
            window.setTimeout(() => { window.location.replace('https://live.artmark.ro') }, this.timeToRedirect * 1000)
        },
        reloadAll (now) {
            if(now === true) {
                window.location.reload()
                return;
            }

            this.timeToRedirect = this.getRndInteger(5, 30)
            window.setTimeout(() => { window.location.reload() }, this.timeToRedirect * 1000)
        },
        openLotsForRecall () {
            if (! this.showLots) {
                this.$store.dispatch('toggleLotsVisibility')
            }
        },
    },
    mounted () {
        if(this.auction.s == this.AUCTION_LIVE_STATUS_HOME) {
            this.redirectHome()
        } else if(this.auction.s == this.AUCTION_LIVE_STATUS_OLD) {
            this.redirectOld()
        }
    }
}
</script>
